import { fmtDate } from "@/lib/helpers";

// Niveaux visuels : 🟢 À jour · 🟠 Échéance proche · 🔴 Expiré
export const ST = {
  a_jour: { dot: "bg-green-500", cls: "bg-green-50 text-green-800 border-green-200", label: "À jour" },
  proche: { dot: "bg-orange-500", cls: "bg-orange-50 text-orange-800 border-orange-200", label: "Échéance proche" },
  expire: { dot: "bg-red-500", cls: "bg-red-50 text-red-800 border-red-200", label: "Expiré" },
};
export const dueText = (e) => e.status === "expire" ? `expiré depuis ${-e.days_left} jour${-e.days_left > 1 ? "s" : ""}` : e.status === "proche" ? `expire dans ${e.days_left} jour${e.days_left > 1 ? "s" : ""}` : fmtDate(e.expires_on);

export function EquipmentBadge({ e, testid }) {
  const s = ST[e.status] || ST.a_jour;
  return <span data-testid={testid} className={`inline-flex items-center gap-1.5 text-xs font-bold px-2 py-1 rounded-full border ${s.cls}`}><span className={`w-2 h-2 rounded-full ${s.dot}`} />{dueText(e)}</span>;
}
